import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, directClone } from 'intact-vue-next';
import { eachChildren, isComponentVNode } from '../utils';
import { TableColumn } from './column';
import { createContext } from '../context';
export var context = createContext();
export function useColumns() {
  var instance = useInstance();
  var columns = [];
  var maxRows = 0;
  var maxCols = 0;
  var cols = [];
  var currentVNode = null;
  instance.on('$receive:children', handleChildren);
  function handleChildren() {
    var _instance$get = instance.get(),
      children = _instance$get.children;
    columns = [];
    maxRows = 0;
    maxCols = 0;
    cols = [];
    currentVNode = null;
    loopColumn(children, null, 0);
  }
  function loopColumn(children, parentProps, row) {
    // add a flag, when we enter to the map callback set it to true,
    // because it may have children but it has not TableColumn
    var ret = false;
    var isFirstColumn = true;
    eachChildren(children, function (vNode) {
      if (isComponentVNode(vNode, TableColumn)) {
        if (isFirstColumn) {
          var nextRow = row + 1;
          if (nextRow > maxRows) maxRows = nextRow;
          if (!columns[row]) columns[row] = [];
          isFirstColumn = false;
        }
        ret = true;
        var clonedVNode = directClone(vNode);
        if (currentVNode) currentVNode.props.nextVNode = clonedVNode;
        var props = _extends({}, clonedVNode.props, {
          cols: 0,
          rows: 0,
          prevVNode: currentVNode
        });
        clonedVNode.props = props;
        columns[row].push(clonedVNode);
        handleProps(props, parentProps, row, clonedVNode);
      }
    });
    return ret;
  }
  function handleProps(props, parentProps, row, vNode) {
    var children = props.children;
    if (children && loopColumn(children, props, row + 1)) {
      // if the column has children columns, then set the row to 1
      props.rows = 1;
    } else {
      // if the column has not children columns, then we must calculate
      // the rows after loop all columns.
      props.children = null;
      props.cols = 1;
      cols.push(props);
      if (!props.hidden) maxCols++;
      Object.defineProperty(props, 'rows', {
        get: function get() {
          return maxRows - row;
        },
        enumerable: true
      });
      currentVNode = vNode;
    }
    // update the parent's cols after hanlding all children columns
    if (parentProps) {
      parentProps.cols += props.cols;
    }
  }
  function getColumns() {
    return columns;
  }
  function getCols() {
    return cols;
  }
  function getData() {
    return {
      columns: columns,
      cols: cols,
      maxRows: maxRows,
      maxCols: maxCols
    };
  }
  return {
    getColumns: getColumns,
    getCols: getCols,
    getData: getData
  };
}